import React from 'react';
import { Flex, Box, Heading, Text, Border } from 'rebass';
import styled from 'styled-components';
import { defaultProps } from 'recompose';
import HomeIcon from 'react-icons/lib/fa/home';
import FacebookIcon from 'react-icons/lib/fa/facebook-official';
import GithubIcon from 'react-icons/lib/fa/github-square';
import Link from '../app/components/link';
import Logo from '../app/components/logo';
import Emoji from '../app/components/emoji';
import { contact } from '../app/data';

const FourOhFour = styled(Flex)`
  height: 100vh;
`;

const Center = defaultProps({
  justify: 'center',
})(Flex);

export default () => (
  <FourOhFour
    column
    pt={3}
  >
    <Center>
      <Link to="/">
        <Logo.Icon
          width={100}
          height={100}
        />
      </Link>
    </Center>
    <Center
      align="center"
      flex="1 0 auto"
      column
      mx={[5, 0]}
      px={[0, 0]}
    >
      <Center
        w={1}
        py={2}
      >
        <Text center is="div">
          The page you are looking for can&apos;t be found.
          <Emoji>😟</Emoji>
        </Text>
      </Center>
      <Center>
        <Heading
          is="h1"
          f="120px"
        >
          404
        </Heading>
      </Center>
    </Center>
    <Center pb={[0, 0, 3]}>
      <Border
        py={3}
        px={2}
        top
        bottom
        w={['100%', '100%', '417px']}
      >
        <Flex
          align="center"
          justify="center"
        >
          <Box pr={2}>
            <Link
              to="/"
              color="black"
            >
              <Text f={2}>
                <HomeIcon size={28} />
              </Text>
            </Link>
          </Box>
          <Box pr={2}>
            <Link
              href={contact.facebookPage.url}
              target="_blank"
              color="black"
            >
              <FacebookIcon size={28} />
            </Link>
          </Box>
          <Box>
            <Link
              href={contact.githubProfile.url}
              target="_blank"
              color="black"
            >
              <GithubIcon size={28} />
            </Link>
          </Box>
        </Flex>
      </Border>
    </Center>
  </FourOhFour>
);



// WEBPACK FOOTER //
// ./src/pages/404.js